import { MatSnackBar } from "@angular/material/snack-bar";
import { map, OperatorFunction } from "rxjs";

export interface BusinessWarning {
  warnings?: BusinessWarningContent[];
}

interface BusinessWarningContent {
  additionalProperties: {[key: string]: string | number};
  code: string;
  message: string;
}

const BUSINESS_WARNING_TRANSLATION = {
  MAX_NUMBER_OF_LEGAL_ABSENCE_JUSTIFIED_WITH_WRITTEN_REASON_EXCEEDED: (additionalProperties: {[key: string]: string | number}) => {
    return `Attention ! Nombre de 1/2 jours avec motifs (C, E, G, J) acceptés par le chef d'établissement dépassé : ${additionalProperties.currentNumberOfLegalAbsenceJustifiedWithWrittenReason} / ${additionalProperties.maxWrittenReasonJustificationForLegalAbsence}.`;
  }
};

export function captureBusinessWarningOperator<T>(snackBar: MatSnackBar): OperatorFunction<T & BusinessWarning, T> {
  return map((response: T & BusinessWarning) => {
    if (response && response.warnings && response.warnings.length > 0) {
      const warnings = response.warnings.map(warning => {
        const translation = BUSINESS_WARNING_TRANSLATION[warning.code];
        return typeof translation === 'function' ? translation(warning.additionalProperties) : translation;
      }).join(', ');
      snackBar.open(warnings, null, {duration: 5000});
    }
    return response;
  });
}
